import React from 'react'
import PropTypes from 'prop-types'

import styles from './../style/VnsshniyVid.module.scss'

import { Container, Image } from 'react-bootstrap'

import WhiteBlockTitle from './WhiteBlockTitle'

class VnsshniyVid extends React.Component {

  constructor(props) {
    super(props)

    this.state = {
      active: 0
    }
  }

  changeActive = ( k ) => {
    this.setState({
      active: k
    })
  }

  render() {

    const { assets_path, data } = this.props,
    { active } = this.state

    return (
      <section className={styles.section}>
        <Container>
          <WhiteBlockTitle
            title={data?.title}
          />
          <div className={styles.text}>{data?.text}</div>
          <div className={styles.content}>
            <div className={`${styles.content_image_mob} d-lg-none`}>
              <Image src={`/${assets_path}/images/lestnici/vneshniyvid_mob.png`} width={257} height={423} alt={`Шикарный внешний вид моб.`} />
              <div>
                {data?.list.map( ( elm, k ) => (
                  <div onClick={() => this.changeActive( k )} className={`${k == active ? styles.content_image_mob_icon_active : styles.content_image_mob_icon}`}>
                    <svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M7.49219 1.10547V13.8949" stroke="white" strokeLinecap="round"/>
                      <path d="M13.8945 7.49023L1.10506 7.49023" stroke="white" strokeLinecap="round"/>
                    </svg>
                  </div>
                ))}
              </div>
            </div>
            {data?.list.map( ( elm, k ) => (
              <div className={`${k == active ? styles.card_active : styles.card}`}>
                <div className={styles.card_top}>
                  <div className={styles.card_title}>{elm.name}</div>
                  <div>[Комплектация]</div>
                </div>
                <div className={styles.card_text}>{elm.text}</div>
              </div>
            ))}
            <Image className={`${styles.content_image} d-none d-lg-block`} src={`/${assets_path}/images/lestnici/vneshniyvid.png`} width={430} height={423} alt={`Шикарный внешний вид`} />
          </div>
        </Container>
      </section>
    )
  }
}

VnsshniyVid.propTypes = {
  assets_path: PropTypes.string,
  data: PropTypes.object
}

VnsshniyVid.defaultProps = {
  assets_path: ``,
  data: {}
}

export default VnsshniyVid